import { useQuery } from "@tanstack/react-query";

import useEmailStore from "@store/useEmailStore";
import useSystemStore from "@store/useSystemStore";
import emailService from "@services/email.service";
import { THREAD_QUERY_KEY, QUERY_CACHE_DEFAULT_EXPIRATION_MS } from "@config/query";

export function useGetThread(enabled: boolean = true) {
  const { threadId } = useEmailStore();
  const { isAppActive } = useSystemStore();

  const { data, error, isLoading, fetchStatus, isPlaceholderData, refetch } = useQuery({
    enabled: enabled && isAppActive && !!threadId,
    queryKey: [THREAD_QUERY_KEY, threadId],
    queryFn: async () => {
      return await emailService.getThread(threadId);
    },
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
    retry: false,
  });

  return { data, error, isLoading, fetchStatus, isPlaceholderData, refetch };
}
